<div class="flex-column gap justify-content-start">
    <app-date-input
        [form]="form"
        class="pt-2"
        id="date"
        [prefix]="prefix"
    ></app-date-input>
    @for (ratingControl of form.controls.ratings.controls; track $index) {
        <div class="flex gap justify-content-between align-items-center">
            <app-select-input
                [form]="ratingControl"
                id="rating"
                valueKey="value"
                class="flex-1"
                [showClear]="!ratingControl.value.isRequired"
                [label]="ratingControl.value.name || (prefix + 'fields.rating')"
                [showHelpText]="ratingControl.value.description !== ''"
                [helpText]="ratingControl.value.description"
                [staticOptions]="serviceWaitingListUnitEnumValues[ratingControl.value.type]"
            ></app-select-input>
        </div>
    }

    <div class="font-bold">
        {{ prefix + 'totalPoints' | translate }}: {{ totalPoints() }}
    </div>
</div>
